import React, { useEffect, useState } from 'react';
import Nav from '../../components/Nav/Nav';
import ratedPeople from './Assets/about.png';
import smallRatedPeople from '../assets/rating_header.png';
import Footer from '../../components/Footer/Footer';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';
import DashboardNav from '../../components/Nav/DashboardNav'
import { useNavigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import baseUrl from '../../components/baseUrl'
import axios from 'axios'
import SuccessModal from './SuccessModal'
import errorIcon from '../../components/assets/error.svg';
import StarRating from '../../components/Starrating';

const Contact = () => {
    const [message, setMessage] = useState('')
    const navigate = useNavigate()
    const [messageError, setMessageError] = useState('')
    const [email, setEmail] = useState('')
    const [name, setName] = useState('')
    const [nameError, setNameError] = useState('')
    const [loading, setLoading] = useState(false)
    const [user, setUser] = useState(null)
    const [accessToken, setAccessToken] = useState()
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showModal, setShowModal] = useState(false);

    // Decode the data 
    function decodeData(data) {
        return atob(data); // Base64 encoding
    }
    useEffect(() => {
        const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
        // Decode the JWT token
        const decodedToken = storeToken ? decodeData(storeToken) : null;
        const userInfo = decodedToken ? jwtDecode(decodedToken) : null;
        if (userInfo) {
            setAccessToken(decodedToken)
            setUser(userInfo?.user)
        }

    }, [navigate])


    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMessage('');
        setLoading(true);

        // Simple email validation regex
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!name || !email || !message) {
            setError('All fields are required.');
            setLoading(false);
            return;
        }

        if (!emailRegex.test(email)) {
            setError('Please enter a valid email address.');
            setLoading(false);
            return;
        }

        // Proceed only if all validations pass
        const requestData = {
            email: email,
            name: name,
            message: message
        };

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}/contactUsForm`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: requestData
        };

        try {
            const response = await axios.request(config);

            if (response.data.success) {
                setShowModal(true); // Show success modal
            } else {
                setError("Error: " + response.data.error);
            }
        } catch (error) {
            setError("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };


    const resetFields = () => {
        setName('');
        setEmail('');
        setMessage('');
    };
    return (
        <div className='overflow-x-hidden '>
            {showModal && (
                <SuccessModal setShowModal={setShowModal} resetFields={resetFields} />
            )}

            {user ? <DashboardNav /> : <Nav />}
           <div className='relative  w-full flex flex-col gap-[50px] bg-custom-gradient h-[507px] md:h-[345px] lg:h-[447px] xl:h-[500px] '>

                <div className='w-full h-full flex items-end'>
                    <img src={ratedPeople} alt="ratedPeople" className='absolute bottom-0 md:left-0  h-auto sm:w-[500px] md:w-[45%] lg:w-[49%] xl:w-[48%] xl:max-w-[48%]' />
                    <div className='absolute w-full top-[124px] md:top-[146px] md:right-[40px] lg:right-[66px] lg:top-[195px] xl:top-[219px] xl:right-[64px] flex flex-col gap-2 text-white text-center sm:items-center md:items-start md:mt-[0px] md:w-[340px]  lg:w-[464px] xl:w-[664px] md:text-start pt-[0px]'>
                        
                        <div className='flex justify-center items-center md:justify-start mb:[0px] md:mb-[14px]'>
                <StarRating rating={4} />
              </div>
                    <h1 className='w-3/4 mx-auto md:mx-0 md:w-full leading-[32px] tracking-[-0.02em] font-black text-center md:text-start  md:px-0 text-[24px] lg:text-big xl:text-hb'>Expand your reach. Connect with real customers</h1>
                    
                    <p className='font-medium text-sm xl:text-lg lg:mt-[14px] px-8 md:px-0'>Discover honest and unbiased reviews that help you make informed choices</p>
                    </div>

                    </div>

                    </div>
                    <div className='w-full px-[26px] md:px-[204px] lg:px-[234px] xl:px-[341px] items-center justify-center mt-[34px] lg:mt-[60px] xl:mt-[48px]'>
                        <div className='flex flex-col mb-[18px] md:mb-[33px] lg:mb-[41px] xl:mb-[48px] gap-2 text-black items-center text-center'>
                            <h1 className=' w-full gap-4 font-black text-center  justify-center px-[24px] md:px-0 text-xl lg:text-huge xl:text-hb'>Contact Us</h1>
                            <p className=' font-medium text-sm text-center '>If you have any questions email us at</p>
                                <a href="mailto:info@rateavendor.com" className="text-center  font-medium text-sm text-ravblue underline"> info@rateavendor.com </a>

                        </div>            
                        <div className=' flex flex-col p-4 gap-[15px] lg:gap-[17px]'>
                            {/* {commentError === "Comment is required" && (
                    <div className='w-full flex items-center justify-center mb-[14px] transform transition-all ease-in-out duration-300'>
                      <div className="w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] px-[12px] h-[30px]">
                        <img src={errorIcon} alt="" className="size-[14px]" />
                        <p className="font-normal text-[#EB0728] text-[10px] leading-[12.13px]">{commentError}</p>
                      </div>
                    </div>
                  )} */}
            
                                {error && (
                                    <div className="w-fit flex gap-[8px] items-center self-center bg-[#FFDFE4] rounded-[30px]  px-[12px] h-[30px]">
                                        <img src={errorIcon} alt="" className="size-[14px]" />
                                        <p className="font-normal text-[#EB0728] text-[10px] leading-[12.13px]">
                                            {error}
                                        </p>
                                    </div>

                                )}
                                <input
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    type="text"
                                    placeholder='Enter your name'
                                    required
                                    className='px-[19px] h-[45px] lg:h-[50px] w-full border border-[#c1c1c1]/50 rounded-[80px] text-black text-base outline-none font-medium'
                                />
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="email"
                                    placeholder='Enter your email'
                                    required
                                    className='px-[19px]  h-[45px] lg:h-[50px] w-full rounded-[80px] border border-[#c1c1c1]/50 text-black text-base outline-none font-medium'
                                />
                                <textarea
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    placeholder='Write your message'
                                    required
                                    className='resize-none  w-full min-h-[208px] border border-[#c1c1c1]/50 md:min-h-[207px] px-[19px] py-[11px] rounded-[15px] text-black text-base  font-medium'
                                ></textarea>
                                <button
                                    type='submit'
                                    onClick={handleSubmit}
                                    className={`relative hover:opacity-70 ${loading ? 'border-[#A2CEFF]' : 'border border-white'
                                        }  text-[#FFFFFF] text-sm font-bold w-full h-[45px] bg-ravblue mt-1.5 md:mt-4 mb-[235px] md:mb-[239px] lg:mb-[192px] xl:mb-[192px] xl:h-[50px] rounded-[80px] flex items-center justify-center transform transition-all ease-in-out duration-300`}
                                    disabled={loading} // Disable the button while loading
                                >
                                    {/* Spinner overlay */}
                                    {loading ? (
                                        <AiOutlineLoading3Quarters className="absolute animate-spin" />)

                                        : (<span>
                                            Submit
                                        </span>
                                        )}
                                </button>


                            </div>

                

            </div>

            <Footer />
        </div>

    )
}

export default Contact
